import _ from 'lodash'
import {
  BESTSELLER_FILTER_TYPE_MAP
} from '../../constants/globalTypes'
import {
  GA_KEY as DASHBOARD_KEY
} from '../Dashboard/OperatingDashboard/SalesPerformance/SalesPerformance.ga'
import {
  FIELD as TABLE_LINK_FIELD
} from '../Dashboard/OperatingDashboard/SalesPerformance/RankingTable/RankingTable'

export const GA_CLICK_ACTION = {
  TABLE_SORT: 'TABLE_SORT',
  EXPORT_EXCEL: 'EXPORT_EXCEL',
  TABLE_LINK: 'TABLE_LINK',
  TABLE_PAGINATION: 'TABLE_PAGINATION'
}

const COMMON_GA_KEYS = [
  DASHBOARD_KEY.TABLE_SORT_AMOUNT,
  DASHBOARD_KEY.TABLE_SORT_QUANTITY,
  DASHBOARD_KEY.TABLE_LINK_AVAILABLE_QUANTITY
]

const GA_KEY = {
  ..._.pick(DASHBOARD_KEY, COMMON_GA_KEYS),
  EXPORT_EXCEL: 'EXPORT_EXCEL',
  TABLE_PAGINATION: 'TABLE_PAGINATION'
}

const GA_KEY_MAP = {
  [GA_KEY.TABLE_SORT_AMOUNT]: 'hourrank_list_orderamt',
  [GA_KEY.TABLE_SORT_QUANTITY]: 'hourrank_list_ordercnt',
  [GA_KEY.TABLE_LINK_AVAILABLE_QUANTITY]: 'hourrank_list_availcnt',
  [GA_KEY.EXPORT_EXCEL]: 'hourrank_list_downloadfile',
  [GA_KEY.TABLE_PAGINATION]: 'hourrank_list_pages'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type, payload } = action
  let key
  switch (type) {
    case GA_CLICK_ACTION.TABLE_SORT: {
      const map = {
        [BESTSELLER_FILTER_TYPE_MAP.AMOUNT.key]: GA_KEY.TABLE_SORT_AMOUNT,
        [BESTSELLER_FILTER_TYPE_MAP.QUANTITY.key]: GA_KEY.TABLE_SORT_QUANTITY
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.TABLE_LINK: {
      const map = {
        [TABLE_LINK_FIELD.AVAILABLE_QUANTITY]: GA_KEY.TABLE_LINK_AVAILABLE_QUANTITY
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.EXPORT_EXCEL:
    case GA_CLICK_ACTION.TABLE_PAGINATION:
      key = GA_KEY[type]
      break
    default:
      break
  }
  const i13nModel = {
    category: 'hourrank',
    action: 'hourranklist',
    label: GA_KEY_MAP[key],
    ...customizeI13nModel
  }
  return i13nModel
}
